<template>
  <div class="min-h-screen bg-gray-100">
    <OfflineIndicator />
    <InactivityTimer
      v-if="isAuthenticated && $route.path !== '/dashboard'"
      :timeout="inactivityTimeout"
      @timeout="handleInactivityTimeout"
    />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useFacilityStore } from './stores/facilityStore'
import OfflineIndicator from './components/shared/OfflineIndicator.vue'
import InactivityTimer from './components/shared/InactivityTimer.vue'

const router = useRouter()
const route = useRoute()
const facilityStore = useFacilityStore()

const isAuthenticated = computed(() => facilityStore.isAuthenticated)
const inactivityTimeout = computed(() => facilityStore.settings?.inactivityTimeout || 60)

function handleInactivityTimeout() {
  router.push('/dashboard')
}
</script>
